module.exports = __webpack_public_path__ + "static/media/T10-01.edc73bfe.svg";